import { render, staticRenderFns } from "./GPDRForm.vue?vue&type=template&id=37a52d88"
import script from "./GPDRForm.vue?vue&type=script&lang=js"
export * from "./GPDRForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports